import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy } from 'react';

const LazyMain = lazy(() =>
  import('./main')
    .then((module) => ({ default: module.Main }))
    .catch(() => {
      document.location.reload();
      return { default: (): JSX.Element => <></> };
    })
);

export const Main = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyMain />
  </Suspense>
);
